import { render, staticRenderFns } from "./CircleStatistic.vue?vue&type=template&id=579c5025"
import script from "./CircleStatistic.vue?vue&type=script&lang=js"
export * from "./CircleStatistic.vue?vue&type=script&lang=js"
import style0 from "./CircleStatistic.vue?vue&type=style&index=0&id=579c5025&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports